import {Directive, ElementRef, Input, OnChanges, OnDestroy, Renderer2} from '@angular/core';
import {Avatar, Style} from '@dicebear/core';
import glyphs from '@dicebear/styles/glyphs.json';

const glyphsStyle = new Style(glyphs);

@Directive({
  selector: 'img[appUserAvatar]',
  standalone: true
})
export class UserAvatarDirective implements OnChanges, OnDestroy {
  @Input() appUserAvatar: string | null | undefined;
  @Input() avatarSeed: string | number | null | undefined;

  private pendingImage: HTMLImageElement | null = null;

  constructor(private element: ElementRef<HTMLImageElement>, private renderer: Renderer2) {}

  ngOnChanges(): void {
    this.cancelPendingImage();

    // Default preset: only the seed changes, so each user keeps the same Glyphs avatar.
    const placeholder = new Avatar(glyphsStyle, {
      seed: String(this.avatarSeed ?? 'innporting')
    }).toDataUri();
    this.renderer.setProperty(this.element.nativeElement, 'src', placeholder);

    const source = this.appUserAvatar?.trim();
    if (!source) {
      return;
    }

    const image = new Image();
    this.pendingImage = image;
    image.onload = () => {
      if (this.pendingImage === image) {
        this.renderer.setProperty(this.element.nativeElement, 'src', source);
        this.cancelPendingImage();
      }
    };
    image.onerror = () => {
      if (this.pendingImage === image) {
        this.cancelPendingImage();
      }
    };
    image.src = source;
  }

  ngOnDestroy(): void {
    this.cancelPendingImage();
  }

  private cancelPendingImage(): void {
    if (this.pendingImage) {
      this.pendingImage.onload = null;
      this.pendingImage.onerror = null;
      this.pendingImage = null;
    }
  }
}
